import { useApi } from "../../api/hooks/use-api.ts";
import { ApiMethod } from "../../api/types.ts";
import { withObjectPayload } from "../../api/payload.ts";

export const useProfileApi = () => {
    const { sendProtectedRequest } = useApi();

    // OK: payload is the profile object. Error: payload is the error object.
    const getProfile = async () => {
        const response = sendProtectedRequest(ApiMethod.GET, process.env.REACT_APP_FPSB_PORTAL_REQUEST_ENDPOINT + '&token=' + process.env.REACT_APP_FPSB_PORTAL_TOKEN + '&action=profile');

        return response.then(withObjectPayload);
    };

    const postProfile = async (profile) => {
        const response = sendProtectedRequest(ApiMethod.POST, process.env.REACT_APP_FPSB_PORTAL_REQUEST_ENDPOINT + '&token=' + process.env.REACT_APP_FPSB_PORTAL_TOKEN + '&action=profile', profile);

        return response.then(withObjectPayload);
    };

    const getPassword = async () => {
        const response = sendProtectedRequest(ApiMethod.GET, process.env.REACT_APP_FPSB_PORTAL_REQUEST_ENDPOINT + '&token=' + process.env.REACT_APP_FPSB_PORTAL_TOKEN + '&action=password');

        return response.then(withObjectPayload);
    };

    const updatePassword = async (currentPassword:string, newPassword:string) => {
        const response = sendProtectedRequest(ApiMethod.POST, process.env.REACT_APP_FPSB_PORTAL_REQUEST_ENDPOINT + '&token=' + process.env.REACT_APP_FPSB_PORTAL_TOKEN + '&action=password', {
            current_password: currentPassword,
            new_password: newPassword,
        });

        return response.then(withObjectPayload);
    };

    // OK: payload is { url, token } for the authenticator app.
    const getTotpSecret = async () => {
        const response = sendProtectedRequest(ApiMethod.GET, process.env.REACT_APP_FPSB_PORTAL_REQUEST_ENDPOINT + '&token=' + process.env.REACT_APP_FPSB_PORTAL_TOKEN + '&action=totpSecretKey');

        return response.then(withObjectPayload);
    }

    const activateTotp = async (code:string) => {
        const payload = {
            "code": code
        }
        const response = sendProtectedRequest(ApiMethod.POST, process.env.REACT_APP_FPSB_PORTAL_REQUEST_ENDPOINT + '&token=' + process.env.REACT_APP_FPSB_PORTAL_TOKEN + '&action=activateTotp', payload);

        return response.then(withObjectPayload);
    }

    const deactivateTotp = async () => {
        const response = sendProtectedRequest(ApiMethod.POST, process.env.REACT_APP_FPSB_PORTAL_REQUEST_ENDPOINT + '&token=' + process.env.REACT_APP_FPSB_PORTAL_TOKEN + '&action=deactivateTotp', {});

        return response.then(withObjectPayload);
    }

    return { getProfile, postProfile, getPassword, updatePassword, getTotpSecret, activateTotp, deactivateTotp };
};
